import { Injectable } from '@angular/core';
import { LoanApplicationTaskApi } from '../../../../../generated/internalApi/api/LoanApplicationTaskApi';
import { Observable, Subject, throwError } from 'rxjs';
import { LoanAppTask } from '../../models/index';
import { SessionService } from '../session/shared/session/session-service/session.service';
import { ApiService } from '../api.service';

@Injectable()
export class LoanApplicationTasksService extends ApiService {
  public tasks: Subject<LoanAppTask[]> = new Subject<LoanAppTask[]>();
  private tasksCache: LoanAppTask[] = [];

  constructor(
    private loanApplicationTaskApi: LoanApplicationTaskApi,
    protected sessionService: SessionService) {
    super(sessionService);
  }

  getTasksFromApi(): Observable<LoanAppTask[]> {
    const loanApplicationGuid = this.sessionService.personalLoanSession.data.loanApplicationGuid;

    return this.loanApplicationTaskApi.loanApplicationTaskGetLoanApplicationTasks(
      loanApplicationGuid,
      this.authToken
    )
    .map(response => {
      this.tasks.next(response.data);
      return this.tasksCache = response.data;
    })
    .catch(err => {
      console.error(err);
      return throwError(err);
    });
  }

  getTasks(fromApi: boolean = false): Observable<LoanAppTask[]> {
    if (!this.tasksCache.length || fromApi) {
      return this.getTasksFromApi();
    }

    this.tasks.next(this.tasksCache);

    return new Observable<LoanAppTask[]>(observer => {
      observer.next(this.tasksCache);
      observer.complete();
    });
  }

  getSelectedLoanApplicationTasks(): Observable<LoanAppTask[]> {
    const loanApplicationGuid = this.sessionService.personalLoanSession.data.loanApplicationGuid;

    return this.loanApplicationTaskApi.loanApplicationTaskGetLoanApplicationTasks(
      loanApplicationGuid,
      this.authToken
    )
    .map(response => response.data)
    .catch(err => {
      console.error(err);
      return throwError(err);
    });
  };
}
